<template>
    <div class="login-container">
        <div class="login-shell">
            <loginHeader class="login-page-header"></loginHeader>

            <div class="login-main">
                <section class="login-hero">
                    <h1 class="hero-title">
                        Smart <span>Invoicing</span>,<br>
                        <strong>Simplified</strong> for You.
                    </h1>
                    <p class="hero-subtitle">
                        Create, send, and manage invoices effortlessly.<br>
                        Get paid faster with Swift Invoice.
                    </p>

                    <div class="feature-list">
                        <div class="feature-item">
                            <div class="feature-icon feature-icon-blue">
                                <i class="el-icon-document"></i>
                            </div>
                            <div>
                                <div class="feature-title">Professional Invoices</div>
                                <div class="feature-text">Create beautiful invoices in minutes</div>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon feature-icon-purple">
                                <i class="el-icon-data-line"></i>
                            </div>
                            <div>
                                <div class="feature-title">Real-time Tracking</div>
                                <div class="feature-text">Track payments and invoice status</div>
                            </div>
                        </div>
                        <div class="feature-item">
                            <div class="feature-icon feature-icon-green">
                                <i class="el-icon-lock"></i>
                            </div>
                            <div>
                                <div class="feature-title">Secure & Reliable</div>
                                <div class="feature-text">Your data is safe with enterprise-grade security</div>
                            </div>
                        </div>
                    </div>

                    <img class="login-illustration" src="@/static/swift_invoice_login_illustration_no_logo.png" alt="">
                </section>

                <section class="login-card-wrap">
                    <el-form class="card-box login-form" autoComplete="on" :model="loginForm" :rules="loginRules"
                             ref="loginForm"
                             v-if="authMode === 'login'"
                             label-position="left">
                        <div class="form-heading">
                            <h2>Welcome back</h2>
                            <p>Sign in to your account to continue</p>
                        </div>

                        <el-form-item prop="email" class="formusername">
                            <label class="field-label">Email</label>
                            <el-input name="email" autofocus="true" prefix-icon="el-icon-message" type="text"
                                      v-model="loginForm.email" autoComplete="on" placeholder="Enter your email"
                                      @keyup.native.enter="handleLogin"/>
                        </el-form-item>

                        <el-form-item prop="password" class="formpassword">
                            <label class="field-label">Password</label>
                            <el-input name="password" prefix-icon="el-icon-lock" type="password"
                                      v-model="loginForm.password" autoComplete="on"
                                      placeholder="Enter your password" @keyup.native.enter="handleLogin"/>
                        </el-form-item>

                        <div class="login-options-row">
                            <el-checkbox v-model="rememberMe">Remember me</el-checkbox>
                            <button type="button" class="forgot-password-button" @click="openForgotPasswordDialog">
                                Forgot password?
                            </button>
                        </div>

                        <el-button type="primary" class="sign-in-button" :disabled="cantLogin" :loading="loading"
                                   @click.native.prevent="handleLogin">Sign in
                        </el-button>

                        <button type="button" class="switch-auth-button" @click="switchToRegister">
                            Create account
                        </button>

                    </el-form>

                    <el-form class="card-box login-form" autoComplete="on" :model="registerForm"
                             :rules="registerRules" ref="registerForm" v-else label-position="left">
                        <div class="form-heading">
                            <h2>Create account</h2>
                            <p>Start using Swift Invoice</p>
                        </div>

                        <el-form-item prop="companyName">
                            <label class="field-label">Company name</label>
                            <el-input name="companyName" prefix-icon="el-icon-office-building" type="text"
                                      v-model="registerForm.companyName" autoComplete="on"
                                      placeholder="Enter your company name"/>
                        </el-form-item>

                        <el-form-item prop="email">
                            <label class="field-label">Email</label>
                            <el-input name="registerEmail" prefix-icon="el-icon-message" type="text"
                                      v-model="registerForm.email" autoComplete="on" placeholder="Enter your email"/>
                        </el-form-item>

                        <el-form-item prop="password">
                            <label class="field-label">Password</label>
                            <el-input name="registerPassword" prefix-icon="el-icon-lock" type="password"
                                      v-model="registerForm.password" autoComplete="on"
                                      placeholder="Enter your password" @keyup.native.enter="handleRegister"/>
                        </el-form-item>

                        <el-button type="primary" class="sign-in-button" :disabled="cantLogin"
                                   :loading="registerLoading" @click.native.prevent="handleRegister">Create account
                        </el-button>

                        <button type="button" class="switch-auth-button" @click="switchToLogin">
                            Already have an account? Sign in
                        </button>

                    </el-form>
                </section>
            </div>

            <div class="login-footer">
                <span>© 2026 Swift Invoice. All rights reserved.</span>
                <a href="https://swiftinvoice.io/termsofservice/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                <span>Contact us: goodinvoicego@gmail.com</span>
            </div>
        </div>

        <el-dialog :visible.sync="openBeta" width="40%">
            <div style="font-size: 20px;line-height: 2;">
                Our team completed the first version of the web <br>
                This version will only be available to iPhone users <br>
                We will improve the web function as soon as possible and open it to all <br>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="openIE" width="40%">
            <div style="font-size: 20px;line-height: 2;">
                Sorry, because IE browser has compatibility problems, we do not support IE browser at present, if you need to use, please download
                <a href="https://www.google.com/chrome/">chrome</a>
            </div>
        </el-dialog>

        <el-dialog title="Reset password" :visible.sync="forgotPasswordDialog" width="420px"
                   custom-class="reset-password-dialog">
            <el-form :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="forgotPasswordForm"
                     label-position="top">
                <el-form-item prop="email" label="Email">
                    <el-input prefix-icon="el-icon-message" v-model="forgotPasswordForm.email"
                              placeholder="Enter your email"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="forgotPasswordDialog = false">Cancel</el-button>
                <el-button type="primary" :loading="forgotPasswordLoading" @click="sendResetPasswordEmail">
                    Send reset email
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {validateEmail} from '@/utils/validate'
    import loginHeader from '../../components/common/loginHeader.vue'
    import {initializeCompanySelection} from '@/utils/company'

    export default {
        components: {
            loginHeader
        },
        data: function () {
            const validUsername = (rule, value, callback) => {
                if (!validateEmail(value)) {
                    callback(new Error('Please enter a valid email address'))
                } else {
                    callback()
                }
            }
            const validPassword = (rule, value, callback) => {
                if (value.length < 6) {
                    callback(new Error('Password must be 6 characters or more'))
                } else {
                    callback()
                }
            }
            const validCompanyName = (rule, value, callback) => {
                if (value.length < 1) {
                    callback(new Error('Please fill in your company name'))
                } else {
                    callback()
                }
            }

            return {
                openBeta: false,
                authMode: 'login',
                loginForm: {
                    email: '',
                    password: ''
                },
                registerForm: {
                    companyName: '',
                    email: '',
                    password: ''
                },
                forgotPasswordForm: {
                    email: ''
                },
                loginRules: {
                    email: [{required: true, trigger: 'blur', validator: validUsername}],
                    password: [{required: true, trigger: 'blur', validator: validPassword}]
                },
                registerRules: {
                    companyName: [{required: true, trigger: 'blur', validator: validCompanyName}],
                    email: [{required: true, trigger: 'blur', validator: validUsername}],
                    password: [{required: true, trigger: 'blur', validator: validPassword}]
                },
                forgotPasswordRules: {
                    email: [{required: true, trigger: 'blur', validator: validUsername}]
                },
                loading: false,
                registerLoading: false,
                forgotPasswordLoading: false,
                forgotPasswordDialog: false,
                rememberMe: false,
                openIE: false,
                cantLogin:false
            }
        },
        watch: {
            $route() {
                this.applyAuthModeFromRoute();
            }
        },
        methods: {
            clickBeta() {
                this.openBeta = true;
            },
            applyAuthModeFromRoute() {
                if (this.$route.meta.authMode === 'register') {
                    this.authMode = 'register';
                    return;
                }
                this.authMode = 'login';
            },
            switchToRegister() {
                this.authMode = 'register';
                this.$nextTick(() => {
                    this.$refs.registerForm.clearValidate();
                });
            },
            switchToLogin() {
                this.authMode = 'login';
                this.$nextTick(() => {
                    this.$refs.loginForm.clearValidate();
                });
            },
            openForgotPasswordDialog() {
                this.forgotPasswordForm.email = this.loginForm.email;
                this.forgotPasswordDialog = true;
                this.$nextTick(() => {
                    this.$refs.forgotPasswordForm.clearValidate();
                });
            },
            loginAfterAuthResponse(responseData, loadingKey) {
                let self = this;
                if (this.rememberMe) {
                    localStorage.setItem('rememberLoginEmail', this.loginForm.email);
                } else {
                    localStorage.removeItem('rememberLoginEmail');
                }
                localStorage.setItem('loginInformation', JSON.stringify(responseData));
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        initializeCompanySelection(response.data);
                        self.$router.push('/invoice');
                    }
                    self[loadingKey] = false;
                }).catch(function () {
                    self[loadingKey] = false;
                })
            },
            handleLogin() {
                let self = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.$axios.post('login.htm', {
                            params: {
                                email: this.loginForm.email,
                                password: this.loginForm.password
                            }
                        }).then(response => {
                            if (response.data.errorCode === 0) {
                                this.loginAfterAuthResponse(response.data, 'loading');
                            } else {
                                self.loading = false;
                            }
                        }).catch(function () {
                            self.loading = false;
                        })
                    } else {
                        return false;
                    }
                });
            },
            handleRegister() {
                let self = this;
                this.$refs.registerForm.validate((valid) => {
                    if (valid) {
                        this.registerLoading = true;
                        this.$axios.post('create_invoice_user', {
                            params: {
                                companyName: this.registerForm.companyName,
                                email: this.registerForm.email,
                                password: this.registerForm.password,
                                fromClient: 3,
                                createTime: Math.floor(Date.now() / 1000)
                            }
                        }).then(response => {
                            if (response.data.errorCode === 0) {
                                this.loginAfterAuthResponse(response.data, 'registerLoading');
                            } else {
                                self.registerLoading = false;
                            }
                        }).catch(function () {
                            self.registerLoading = false;
                        })
                    } else {
                        return false;
                    }
                });
            },
            sendResetPasswordEmail() {
                let self = this;
                this.$refs.forgotPasswordForm.validate((valid) => {
                    if (valid) {
                        this.forgotPasswordLoading = true;
                        this.$axios.post('send_reset_password_email', {
                            params: {
                                email: this.forgotPasswordForm.email
                            }
                        }).then(response => {
                            self.forgotPasswordLoading = false;
                            if (response.data.errorCode === 0) {
                                self.forgotPasswordDialog = false;
                                self.$message({
                                    type: 'success',
                                    message: 'Reset password email sent. Please check your inbox.'
                                });
                            }
                        }).catch(function () {
                            self.forgotPasswordLoading = false;
                        })
                    } else {
                        return false;
                    }
                });
            }
        },
        mounted() {
            this.applyAuthModeFromRoute();

            let userAgent = navigator.userAgent;
            let isOpera = userAgent.indexOf("Opera") > -1;
            if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
                //IE浏览器,不让用
                this.openIE = true;
            }

            if (this.openIE) {
                this.cantLogin = true;
            }

            const rememberedEmail = localStorage.getItem('rememberLoginEmail');
            if (rememberedEmail != null && rememberedEmail !== '') {
                this.loginForm.email = rememberedEmail;
                this.rememberMe = true;
            }
        }
    }
</script>

<style scoped>
    .login-container {
        min-height: 100vh;
        text-align: left;
        background:
                radial-gradient(circle at 16% 20%, rgba(13, 125, 247, 0.12), transparent 32%),
                radial-gradient(circle at 70% 10%, rgba(113, 72, 255, 0.09), transparent 26%),
                linear-gradient(135deg, #f7fbff 0%, #ffffff 50%, #f4f8ff 100%);
    }

    .login-shell {
        width: min(1320px, calc(100vw - 96px));
        min-height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding: 36px 0 56px;
        box-sizing: border-box;
    }

    .login-page-header {
        flex: 0 0 auto;
    }

    .login-main {
        flex: 1;
        display: grid;
        grid-template-columns: minmax(460px, 1fr) minmax(430px, 520px);
        align-items: center;
        gap: 90px;
        padding-top: 0;
    }

    .login-hero {
        position: relative;
        min-height: 680px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        padding-bottom: 250px;
        box-sizing: border-box;
    }

    .hero-title {
        margin: 0;
        color: #14234a;
        font-size: 48px;
        line-height: 1.18;
        font-weight: 800;
    }

    .hero-title span {
        color: #0d6dfd;
    }

    .hero-title strong {
        color: #7a3ffc;
        font-weight: 800;
    }

    .hero-subtitle {
        margin: 28px 0 0;
        color: #566584;
        font-size: 18px;
        line-height: 1.55;
    }

    .feature-list {
        display: flex;
        flex-direction: column;
        gap: 22px;
        margin-top: 44px;
    }

    .feature-item {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .feature-icon {
        width: 42px;
        height: 42px;
        flex: 0 0 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #ffffff;
        font-size: 20px;
        box-shadow: 0 14px 26px rgba(37, 99, 235, 0.18);
    }

    .feature-icon-blue {
        background: linear-gradient(135deg, #2f8cff, #1168ef);
    }

    .feature-icon-purple {
        background: linear-gradient(135deg, #9567ff, #6927f2);
    }

    .feature-icon-green {
        background: linear-gradient(135deg, #31dcc2, #10bfa2);
    }

    .feature-title {
        color: #132040;
        font-size: 16px;
        font-weight: 700;
    }

    .feature-text {
        margin-top: 5px;
        color: #61708d;
        font-size: 14px;
    }

    .login-illustration {
        position: absolute;
        left: -24px;
        bottom: -110px;
        width: min(560px, 94%);
        max-width: none;
        pointer-events: none;
        user-select: none;
    }

    .login-card-wrap {
        display: flex;
        justify-content: center;
        padding-top: 0;
    }

    .login-form {
        width: 100%;
        max-width: 500px;
        padding: 54px 48px 48px;
        box-sizing: border-box;
        border: 1px solid rgba(198, 208, 224, 0.82);
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.86);
        box-shadow: 0 24px 70px rgba(31, 45, 74, 0.14);
        backdrop-filter: blur(10px);
    }

    .form-heading {
        text-align: center;
        margin-bottom: 36px;
    }

    .form-heading h2 {
        margin: 0;
        color: #14234a;
        font-size: 28px;
        line-height: 1.25;
        font-weight: 800;
    }

    .form-heading p {
        margin: 12px 0 0;
        color: #61708d;
        font-size: 15px;
    }

    .field-label {
        display: block;
        margin-bottom: 10px;
        color: #17213c;
        font-size: 15px;
        font-weight: 600;
    }

    .login-form /deep/ .el-form-item {
        margin-bottom: 20px;
    }

    .login-form /deep/ .el-input__inner {
        height: 50px;
        border: 1px solid #d7dee9;
        border-radius: 6px;
        color: #17213c;
        font-size: 15px;
        background: rgba(255, 255, 255, 0.92);
    }

    .login-form /deep/ .el-input__inner:focus {
        border-color: #0d7df7;
        box-shadow: 0 0 0 3px rgba(13, 125, 247, 0.12);
    }

    .login-form /deep/ .el-input__prefix {
        color: #8190aa;
    }

    .sign-in-button {
        width: 100%;
        height: 52px;
        margin-top: 6px;
        border: 0;
        border-radius: 6px;
        background: linear-gradient(135deg, #0d6dfd, #0d7df7);
        box-shadow: 0 14px 28px rgba(13, 125, 247, 0.24);
        font-size: 16px;
        font-weight: 700;
    }

    .sign-in-button:hover,
    .sign-in-button:focus {
        background: linear-gradient(135deg, #0c63e7, #0d74ea);
    }

    .login-options-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: -4px 0 22px;
    }

    .login-options-row /deep/ .el-checkbox {
        color: #17213c;
        font-size: 14px;
        font-weight: 500;
    }

    .login-options-row /deep/ .el-checkbox__label {
        color: #17213c;
        font-size: 14px;
        font-weight: 500;
    }

    .forgot-password-button {
        display: inline-flex;
        margin: 0;
        padding: 0;
        border: 0;
        color: #0d6dfd;
        background: transparent;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        cursor: pointer;
    }

    .forgot-password-button:hover,
    .switch-auth-button:hover {
        color: #0b5ed7;
    }

    .switch-auth-button {
        width: 100%;
        margin-top: 22px;
        padding: 0;
        border: 0;
        color: #0d6dfd;
        background: transparent;
        font-size: 15px;
        font-weight: 700;
        line-height: 22px;
        cursor: pointer;
    }

    .login-footer {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 18px;
        margin-top: 24px;
        color: #61708d;
        font-size: 13px;
        line-height: 20px;
        text-align: center;
    }

    .login-footer a {
        color: #61708d;
        text-decoration: none;
    }

    .login-footer a:hover {
        color: #0d6dfd;
    }

    .reset-password-dialog /deep/ .el-dialog__body {
        padding-bottom: 8px;
    }

    @media (max-width: 1100px) {
        .login-shell {
            width: min(720px, calc(100vw - 48px));
        }

        .login-main {
            grid-template-columns: 1fr;
            gap: 42px;
        }

        .login-hero {
            min-height: auto;
            padding-bottom: 280px;
        }
    }

    @media (max-width: 640px) {
        .login-shell {
            width: calc(100vw - 32px);
            padding: 24px 0 36px;
        }

        .login-main {
            padding-top: 28px;
        }

        .login-hero {
            padding-bottom: 210px;
        }

        .hero-title {
            font-size: 38px;
        }

        .login-form {
            padding: 40px 24px 34px;
        }

        .login-options-row {
            align-items: flex-start;
            flex-direction: column;
            gap: 12px;
        }
    }
</style>
